




















































































































































import { TotalAssinantes } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({})
export default class TotalUsuariosCard extends Vue {
  totalAssinantes: number | null = null;
  totalUsuariosAtivos: number | null = null;
  totalHiperConectada: number | null = null;
  totalSuperConectada: number | null = null;
  totalEssencialConectada: number | null = null;
  totalEssencial: number | null = null;
  totalLite: number | null = null;
  totalGratis: number | null = null;

  @Prop() readonly loading!: boolean;
  @Prop() readonly assinantes!: TotalAssinantes[];

  mounted() {
    this.onAssinantesChange(this.assinantes);
  }

  @Watch("assinantes")
  onAssinantesChange(val: TotalAssinantes[]) {
    this.limparAssinantes();
    if (val) {
      const preenchidos = val.filter((x) => x.totalpago);
      if (preenchidos.length > 0) {
        const ultimo = preenchidos[preenchidos.length - 1];

        this.totalAssinantes = ultimo.totalpago;
        this.totalUsuariosAtivos = ultimo.total;
        this.totalHiperConectada = ultimo.hiperconectada;
        this.totalSuperConectada = ultimo.superconectada;
        this.totalEssencialConectada = ultimo.essencialconectada;
        this.totalEssencial = ultimo.essencial;
        this.totalLite = ultimo.lite;
        this.totalGratis = ultimo.gratis;
      }
    }
  }

  limparAssinantes() {
    this.totalAssinantes =
      this.totalUsuariosAtivos =
      this.totalSuperConectada =
      this.totalEssencialConectada =
      this.totalEssencial =
      this.totalLite =
      this.totalGratis =
        null;
  }
}
